export const ALL_TYPES = "allTypes";
export const ALL_POKEMONS = "allPokemons";
export const API_POKEMONS = "apiPokemons";
export const DB_POKEMONS = "dbPokemons"; 